import React from "react";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { Stories } from "../../common/const";
import CommonCard from "../../common/components/CommonCard";

const Testimonial = ({
    testimonialRef
}) => {
    const theme = useTheme();
    return (
        <Box
            id="testimonial"
            ref={testimonialRef}
            sx={{
                pt: 8,
                margin: "0px 6%"
            }}
        >
            <Box width='35%'>
                <Typography fontSize={20}>DCP Student & Alumni Stories</Typography>
                <Typography fontSize={45} align="center" color={theme.palette.secondary.main} fontWeight="600" textAlign="left" sx={{ lineHeight: 1.1 }}>
                    Student & Alumni Experiences
                </Typography>
            </Box>
            <Grid container spacing={2} mt={1}>
                {Stories.map((a, index) => (
                    <Grid item md={4} key={index}>
                        <CommonCard
                          paddingBottom="0px"
                          borderRadius={1}
                          background={theme.palette.primary.main}
                          marginTop="0px"
                          content={
                            <Box
                              display="flex"
                              flexDirection="column"
                              gap={5}
                            >
                                <Typography fontSize={15}>{a.description}</Typography>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={1}
                                > 
                                  <img src={a.images} alt="author"/>
                                  <Box>
                                    <Typography color={theme.palette.secondary.main} fontWeight={600}>{a.name}</Typography>
                                    <Typography fontSize={14}>{a.position}</Typography>
                                  </Box>
                                </Box>
                            </Box>
                          }
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}

export default Testimonial;